export default __webpack_public_path__ + "static/media/vijayLink.5b2827f5.png";